var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasMosaics)?_c('span',{attrs:{"title":_vm.getTranslation('mosaics')}},[_c('MosaicsCircle',{staticStyle:{"width":"16px","height":"16px"},attrs:{"id":"target","mosaics":[]}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }